/*
 * Copyright 2024 The Kokabo Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */


/**
 * The security policy.
 * Use `SecurityAgent.ApplyPolicy(policy)` to apply a policy
 * IMPORTANT:  the policy should be coordinated between the js  and the golang side.
 * check `rpc.NewManager` `SecurityPolicy`
 */
class SecurityPolicy{

    /**
     * If true, the E2EE occurs even over TLS.
     * @type {boolean}
     */
    forceE2EEOverTLS;

    /**
     * Global opt-out exists to support legacy deployments and local debugging; it must be explicitly enabled.
     * @type {boolean}
     */
    optOutE2EE;

    /**
     * Headers are selectively ciphered to reduce plaintext metadata leakage while keeping intermediaries functional.
     * @type {Set<string>}
     */
    headersToCipher;

    /**
     * If true, the keyExchange verification is enforced
     * @type {boolean}
     */
    enforcedE2EEVerification = true;

    constructor(forceE2EEOverTLS , optOutE2EE, headersToCipher){
        this.optOutE2EE = optOutE2EE;
        this.forceE2EEOverTLS = forceE2EEOverTLS;
        this.headersToCipher = headersToCipher;
        this.enforcedE2EEVerification = !optOutE2EE;
    }
}

// Default policy: E2EE enabled, but TLS is treated as sufficient unless forceE2EEOverTLS is enabled.
const DefaultSecurityPolicy = new SecurityPolicy(false, false,  new Set(["Authorization", "Cookie", "Set-Cookie", "kokabo-uuid", "relay"]));

// Opt-out policy disables E2EE everywhere (primarily for controlled environments and compatibility).
const OptOutE2EESecurityPolicy = new SecurityPolicy(false, true, new Set());

export {SecurityPolicy, DefaultSecurityPolicy, OptOutE2EESecurityPolicy};